import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./PrivateEquityService.css";
import Testimonial from "../../../Testimonial/Testimonial";

const PrivateEquityServices = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>
          Private Equity Technology Services | Comprehensive Investment Tech
          Solutions
        </title>
        <meta
          name="description"
          content="Specialized technology services for private equity firms, offering AI-powered deal sourcing, blockchain-enabled due diligence, and advanced portfolio analytics for superior investment performance."
        />
        <meta
          name="keywords"
          content="private equity services, PE technology solutions, investment management software, deal sourcing technology, due diligence tools, portfolio company analytics, LP reporting systems, fund administration software, investment decision support, private equity CRM, deal flow management, investment workflow automation, alternative investment technology, capital call management, investor portal solutions, ESG analytics tools, value creation technology, exit strategy planning, fund accounting software, private markets data, investment thesis validation, co-investment management, secondary market technology, NAV calculation tools, private equity dashboards, investment monitoring systems, AI for private equity, machine learning investments, blockchain for PE firms, data room solutions, document management for PE, compliance tracking software, risk assessment tools, financial modeling for PE, performance attribution analysis"
        />
      </Helmet>

      <div className="pes-main-container">
        <div className="pes-hero-banner">
          <div className="pes-hero-content-wrapper">
            <h1 className="pes-main-heading">Private Equity Services</h1>
            <p className="pes-sub-heading">
              Strategic investment solutions for sustainable growth
            </p>
          </div>
          <div className="pes-animation-elements">
            <div className="pes-orb pes-orb-primary"></div>
            <div className="pes-orb pes-orb-secondary"></div>
            <div className="pes-orb pes-orb-tertiary"></div>
          </div>
        </div>

        <section className="pes-intro-section">
          <div className="pes-content-container">
            <div className="pes-section-header">
              <h2>Comprehensive Private Equity Solutions</h2>
              <p>
                At MK Etech, we provide end-to-end private equity services that
                help investors identify opportunities, maximize returns, and
                navigate complex market dynamics.
              </p>
            </div>
          </div>
        </section>

        <section className="pes-services-section">
  <div className="pes-content-container">
    <h2 className="pes-section-title">Our Services</h2>
    <div className="pes-grid-layout">
      <div className="pes-service-card pes-card-1">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
        </div>
        <h3>Deal Sourcing & Evaluation</h3>
        <p>
          Identifying and assessing investment opportunities with strong
          growth potential and alignment with strategic objectives.
        </p>
      </div>

      <div className="pes-service-card pes-card-2">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
        </div>
        <h3>Due Diligence</h3>
        <p>
          Comprehensive financial, operational, and legal analysis to
          mitigate risks and validate investment theses.
        </p>
      </div>

      <div className="pes-service-card pes-card-3">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
            <polyline points="16 7 22 7 22 13"></polyline>
          </svg>
        </div>
        <h3>Portfolio Management</h3>
        <p>
          Active ownership strategies to enhance value, improve
          operations, and drive growth in portfolio companies.
        </p>
      </div>

      <div className="pes-service-card pes-card-4">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
        </div>
        <h3>Exit Strategy Planning</h3>
        <p>
          Developing and executing optimal exit strategies to maximize
          returns for our investors and partners.
        </p>
      </div>

      <div className="pes-service-card pes-card-5">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <h3>Strategic Partnerships</h3>
        <p>
          Building synergistic relationships between portfolio companies
          and industry leaders to accelerate growth and market penetration.
        </p>
      </div>

      <div className="pes-service-card pes-card-6">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
        </div>
        <h3>Market Research & Analysis</h3>
        <p>
          In-depth industry analysis and market intelligence to identify
          emerging trends and investment opportunities.
        </p>
      </div>

      <div className="pes-service-card pes-card-7">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 19l7-7 3 3-7 7-3-3z"></path>
            <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path>
            <path d="M2 2l7.586 7.586"></path>
            <circle cx="11" cy="11" r="2"></circle>
          </svg>
        </div>
        <h3>Value Creation Planning</h3>
        <p>
          Developing and implementing tailored value creation plans to
          optimize operational efficiency and profitability.
        </p>
      </div>

      <div className="pes-service-card pes-card-8">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
        </div>
        <h3>Capital Structuring</h3>
        <p>
          Designing optimal capital structures to support growth initiatives
          while maintaining financial stability and flexibility.
        </p>
      </div>
      
      <div className="pes-service-card pes-card-9">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        <h3>Financial Modeling</h3>
        <p>
          Building sophisticated financial models to forecast performance,
          evaluate scenarios, and support investment decision-making.
        </p>
      </div>

      <div className="pes-service-card pes-card-10">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
          </svg>
        </div>
        <h3>Transaction Advisory</h3>
        <p>
          Providing expert guidance throughout the transaction process,
          from initial negotiation to final closing and integration.
        </p>
      </div>

      <div className="pes-service-card pes-card-11">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline>
            <polyline points="7.5 19.79 7.5 14.6 3 12"></polyline>
            <polyline points="21 12 16.5 14.6 16.5 19.79"></polyline>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
        </div>
        <h3>Corporate Governance</h3>
        <p>
          Implementing best practices in corporate governance to ensure
          transparency, accountability, and effective oversight.
        </p>
      </div>

      <div className="pes-service-card pes-card-12">
        <div className="pes-icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        <h3>Performance Monitoring</h3>
        <p>
          Establishing robust KPIs and reporting systems to track portfolio
          company performance against strategic objectives.
        </p>
      </div>
    </div>
  </div>
</section>

        <section className="pes-approach-section">
          <div className="pes-content-container">
            <div className="pes-approach-content">
              <div className="pes-approach-text">
                <h2>Our Investment Approach</h2>
                <p>
                  MK Etech employs a disciplined, research-driven approach to
                  private equity investing. We focus on sectors with strong
                  tailwinds and companies with sustainable competitive
                  advantages.
                </p>
                <ul className="pes-feature-list">
                  <li>Long-term value creation</li>
                  <li>Operational improvement initiatives</li>
                  <li>Strategic resource allocation</li>
                  <li>ESG integration</li>
                </ul>
              </div>
              <div className="pes-approach-visual">
                <div className="pes-process-flow">
                  <div className="pes-process-step">
                    <span className="pes-step-indicator">1</span>
                    <span className="pes-step-label">Sourcing</span>
                  </div>
                  <div className="pes-process-connector"></div>
                  <div className="pes-process-step">
                    <span className="pes-step-indicator">2</span>
                    <span className="pes-step-label">Analysis</span>
                  </div>
                  <div className="pes-process-connector"></div>
                  <div className="pes-process-step">
                    <span className="pes-step-indicator">3</span>
                    <span className="pes-step-label">Execution</span>
                  </div>
                  <div className="pes-process-connector"></div>
                  <div className="pes-process-step">
                    <span className="pes-step-indicator">4</span>
                    <span className="pes-step-label">Value Creation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pes-cta-section">
          <div className="pes-content-container">
            <div className="pes-cta-content">
              <h2>Ready to explore private equity opportunities?</h2>
              <p>
                Contact our team to discuss how our private equity services can
                help you achieve your investment goals.
              </p>
              <a
                href="https://wa.me/919155599968?text=Hi!%20I%20am%20interested%20in%20your%20Private%20Equity%20services%20including%20fund%20management%2C%20due%20diligence%2C%20and%20investment%20support.%20Please%20connect%20me%20with%20your%20experts."
                target="_blank"
                rel="noreferrer"
              >
                <button className="pes-cta-button">Get in Touch</button>
              </a>
            </div>
          </div>
        </section>
      </div>

      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateEquityServices;
